import { render } from "./InputNumber.vue?vue&type=template&id=eb5d9d4a"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"
script.render = render

export default script